import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { orderDetailLoad } from 'store/models/order';
import { DetailLoadComponent } from 'components/common';

const OrderValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={orderDetailLoad(props.site.activeDomain)}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(id)}
      render={({ id, item, linkPath }) => {
        const value = (item && item.number) || id;

        return (
          <Fragment>{props.asLink && linkPath ? <Link to={linkPath}>{value}</Link> : <span>{value}</span>}</Fragment>
        );
      }}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.order,
  site: state.site,
});

export default connect(mapState)(OrderValue);
